import React from 'react';
import { jwtDecode } from 'jwt-decode';
import { Navigate } from 'react-router-dom';

const SuperProtectedRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/auth/login" />;
    }

    try {
        const decodedToken = jwtDecode(token);
        
        // Преобразуем allowedRoles в массив, если это строка
        const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

        if (roles.includes(decodedToken.role)) {
            return children;
        } else {
            return <Navigate to="/404" />;
        }
    } catch (error) {
        console.error("Ошибка при декодировании токена: ", error);
        return <Navigate to="/home" />;
    }
}

export default SuperProtectedRoute;